import { createContext, useContext } from 'react'

/**
 * Per-section editing for a player form that opens read-only (Player Details,
 * and Edit Player once it has a player): one section is edited at a time, and
 * the rest show their values.
 */
export interface SectionEditContextValue {
  /** The one section being edited, or null when every section is read-only. */
  editingSection: string | null
  isSaving: boolean
  startEditing: (sectionKey: string) => void
  stopEditing: () => void
}

export const SectionEditContext = createContext<SectionEditContextValue | null>(
  null
)

/**
 * The surrounding section-edit state, or null in a form without read mode (Add
 * Player), where every section is always editable.
 */
export const useSectionEdit = (): SectionEditContextValue | null =>
  useContext(SectionEditContext)

/**
 * True while the fields below should show their values instead of inputs. Set
 * per section by `EditableSection`; false everywhere else, so every other form
 * using the Formik fields is unaffected.
 */
export const FieldReadModeContext = createContext(false)

export const useFieldReadMode = (): boolean => useContext(FieldReadModeContext)
